import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import UserContext, { UserProvider } from './context/user.jsx';

import SignInPage from './pages/sign_in.jsx';
import Dashboard from './pages/dashboard.jsx';
import DashboardHome from './pages/dashboard_home.jsx';
import DashboardLanguages from './pages/dashboard_languages.jsx';
import DashboardFileManager from './pages/dashboard_file_manager.jsx';
import DashboardSections from './pages/dashboard_sections.jsx';
import DashboardSection from './pages/dashboard_section.jsx';
import DashboardPopups from './pages/dashboard_popups.jsx';
import DashboardPopup from './pages/dashboard_popup.jsx';
import DashboardMaps from './pages/dashboard_maps.jsx';
import DashboardMap from './pages/dashboard_map.jsx';
import Backup from './pages/backup.jsx';
import { ModalsProvider } from './context/modals.jsx';

const Index = () => {
	const navigate = useNavigate();
	const user_context = useContext(UserContext);

	if (!user_context.loaded) return <p>Loading...</p>;

	if (!user_context.user) {
		navigate('/sign_in');
	} else {
		navigate('/dashboard');
	}
};

export default function App() {
	return (
		<Router>
			<ModalsProvider>
				<UserProvider>
					<Routes>
						<Route exact path="/" element={<Index element />} />
						<Route path="/sign_in" element={<SignInPage />} />
						<Route path="/dashboard" element={<Dashboard />}>
							<Route path="" element={<DashboardHome />} />
							<Route path="languages" element={<DashboardLanguages />} />
							<Route path="file_manager" element={<DashboardFileManager />} />
							<Route path="backup" element={<Backup />} />
							<Route exact path="sections" element={<DashboardSections />} />
							<Route exact path="sections/:id" element={<DashboardSection />} />
							<Route exact path="popups" element={<DashboardPopups />} />
							<Route exact path="popups/:id" element={<DashboardPopup />} />
							<Route exact path="maps" element={<DashboardMaps />} />
							<Route exact path="maps/:id" element={<DashboardMap />} />
						</Route>
					</Routes>
				</UserProvider>
			</ModalsProvider>
		</Router>
	);
}
